function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import format from "date-fns/format";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import DatePickerIcon from "@mui/icons-material/DateRange";
import IconButton from "@mui/material/IconButton";
//Limitless imports
import OkCancelDialog from "../ok-cancel-dialog/OkCancelDialog";
import ReadOnlyField from "../../form-elements/read-only-field/ReadOnlyField";
import DateRangePicker from "../../date-pickers/DateRangePicker";
import { getDefinedDates } from "../../date-pickers/StaticDateRanges";
const DEFAULT_SELECTION = {
  startDate: getDefinedDates().startOfToday,
  endDate: getDefinedDates().endOfToday,
  key: "selection",
  color: "rgba(0,79,265,0.8)"
};
const useStyles = makeStyles({
  fieldContainers: {
    display: "flex",
    alignItems: "center"
  },
  fieldWrapper: {
    marginRight: 16
  },
  iconButton: {
    height: "50%",
    marginTop: 16,
    marginLeft: 8
  },
  whiteLabelStyles: {
    backgroundColor: "#fff"
  }
});
const DateRangePickerDialog = ({
  dateRange,
  onValueChange,
  background,
  endDateAsTodayAlways,
  defaultSelection,
  iconOnly,
  fromLabel = "From",
  toLabel = "To",
  ...rest
}) => {
  const [showDialog, setShowDialog] = React.useState(false);
  const [dateSelectionRange, setDateSelectionRange] = React.useState(dateRange);
  React.useEffect(() => {
    if (!showDialog) {
      setDateSelectionRange(dateRange);
    }
  }, [dateRange]);
  const classes = useStyles();
  const handleSaveDateRange = () => {
    onValueChange({
      dateRange: dateSelectionRange
    });
    setShowDialog(false);
  };
  const handleDateRangeChange = newDateSelectionRange => {
    if (endDateAsTodayAlways) {
      newDateSelectionRange["endDate"] = getDefinedDates().endOfToday;
    }
    setDateSelectionRange(newDateSelectionRange);
  };
  const {
    startDate,
    endDate
  } = dateSelectionRange;
  let labelStyles = "";
  if (background === "white") {
    labelStyles = classes.whiteLabelStyles;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.fieldContainers
  }, !iconOnly && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.fieldWrapper
  }, /*#__PURE__*/React.createElement(ReadOnlyField, {
    label: fromLabel,
    value: startDate ? format(startDate, "DD/MM") : "-",
    valueContainerStyles: labelStyles
  })), /*#__PURE__*/React.createElement(ReadOnlyField, {
    label: toLabel,
    value: endDate ? format(endDate, "DD/MM") : "-",
    valueContainerStyles: labelStyles
  }), " "), /*#__PURE__*/React.createElement(IconButton, {
    className: `${iconOnly ? "" : classes.iconButton}`,
    onClick: () => setShowDialog(true),
    color: "secondary",
    size: "large"
  }, /*#__PURE__*/React.createElement(DatePickerIcon, null))), showDialog && /*#__PURE__*/React.createElement(OkCancelDialog, {
    title: rest.isSingleRangeSelector ? "Select Date" : "Select a Date Range",
    okLabel: "Confirm",
    okId: "confirmDateRange",
    onCancelClick: () => setShowDialog(false),
    onOKClick: handleSaveDateRange,
    dialogTitleProps: {
      classes: {
        root: classes.dialog
      }
    },
    okDisabled: false
  }, /*#__PURE__*/React.createElement(DateRangePicker, _extends({
    onDateRangeChange: handleDateRangeChange,
    selectionRange: startDate ? dateSelectionRange : defaultSelection
  }, rest))));
};
export default DateRangePickerDialog;
DateRangePickerDialog.propTypes = {
  onValueChange: PropTypes.func.isRequired,
  dateRange: PropTypes.object.isRequired,
  endDateAsTodayAlways: PropTypes.bool.isRequired,
  iconOnly: PropTypes.bool,
  defaultSelection: PropTypes.object,
  background: PropTypes.string,
  fromLabel: PropTypes.string,
  toLabel: PropTypes.string
};
DateRangePickerDialog.defaultProps = {
  endDateAsTodayAlways: false,
  maxDate: getDefinedDates().endOfToday,
  defaultSelection: DEFAULT_SELECTION,
  infiniteEndDate: false,
  iconOnly: false
};